module.exports = __webpack_public_path__ + "img/logo.5f0a8062.svg";